import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import Layout from '../../../layout/default';

const AboutUs = () => {
    return (
        <Layout title="About Us">
            <Container className="my-5">
                <Row className="justify-content-center">
                    <Col md={10} lg={8}>
                        <Card className="shadow-lg border-0">
                            <Card.Body className="p-4">
                                <Card.Title className="text-center mb-4 display-6">About Us</Card.Title>
                                <Card.Text className="text-justify">
                                    <p className="mb-4 text-muted">
                                        Welcome to <strong>Grocenetmart</strong>, your trusted partner for empowering local businesses and manufacturers. We're committed to creating a platform that fosters growth, innovation, and community development.
                                    </p>
                                    <p className="mb-4 text-muted">
                                        Our mission is simple: to provide a seamless and supportive ecosystem for local manufacturers and business associates to thrive. We believe in the power of collaboration and mutual support, and we're dedicated to helping our partners achieve their goals.
                                    </p>
                                    <p className="mb-4 text-muted">
                                        At <strong>Grocenetmart</strong>, we're driven by a passion for excellence and a commitment to integrity. We're proud to be a part of the local community, and we're excited to contribute to its growth and prosperity.
                                    </p>
                                    <p className="text-muted">
                                        Join us on this journey, and let's grow together!
                                    </p>
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Layout>
    );
};

export default AboutUs;
